import SEO from "../../shared/components/common/SEO";
import HreflangTags from "../../shared/components/common/HreflangTags";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Hero from "./features/Hero";
import "./styles/App.css";

export default function AndreMouraPassosSite() {
  return (
    <>
      <SEO />
      <HreflangTags />
      <Header />
      <Hero />
      <Footer />
    </>
  );
}
